"use client";

import { useServices } from "../services-context";

import { useEffect } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

import { SearchCategoryFilters } from "@/components/catalog/search-category-filters";
import { Button } from "@/components/ui";

import { useServiceFilterOptions } from "./use-service-filter-options";

export const ServiceFilters = ({
  hideCategoryPicker = false,
}: {
  hideCategoryPicker?: boolean;
}) => {
  const {
    state: {
      searchQuery,
      selectedCategory,
      selectedLocationId,
      userLocation,
      data,
    },
    actions: { setSearchQuery, setSelectedCategory, requestUserLocation },
  } = useServices();

  const locations = data?.locations ?? [];
  const { eligibleServices, categories, effectiveSelectedCategory } =
    useServiceFilterOptions();

  useEffect(() => {
    if (selectedCategory !== effectiveSelectedCategory) {
      setSelectedCategory(effectiveSelectedCategory);
    }
  }, [selectedCategory, effectiveSelectedCategory, setSelectedCategory]);

  const anyLocationHasDistance = locations.some(
    (loc) => !!loc.latitude && !!loc.longitude,
  );

  const showFindClosest = Boolean(
    data?.shouldGroupServicesByLocation &&
    anyLocationHasDistance &&
    !selectedLocationId &&
    !userLocation,
  );

  const showSearch = eligibleServices.length > 20;
  const showCategories = !hideCategoryPicker && categories.length > 2;

  return (
    <div className="my-4 space-y-2">
      {showFindClosest && (
        <Button
          variant="secondary"
          onClick={() => requestUserLocation()}
          className="motion-preset-slide-right-sm cursor-pointer transition-colors motion-duration-100/scale motion-delay-[50ms]"
          key="closest-to-you-button"
        >
          <FaMapMarkerAlt className="mr-1 inline" />
          <span>Find services closest to You</span>
        </Button>
      )}
      <SearchCategoryFilters
        searchLabel="Search services"
        searchPlaceholder="Search by service name or description..."
        searchValue={searchQuery}
        onSearchChange={setSearchQuery}
        showSearch={showSearch}
        categoryLabel="Choose from a list of categories"
        categoryValue={effectiveSelectedCategory}
        onCategoryChange={setSelectedCategory}
        categories={categories
          .filter((category) => !!category.name)
          .map((category) => ({
            value: category.name,
            label: category.name,
          }))}
        showCategories={showCategories}
      />
    </div>
  );
};

export default ServiceFilters;
